// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { upload16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-upload': IconUpload;
    }
}

/**
 * The icon component for the 'upload' icon
 */
export class IconUpload extends IconSvg {
    public constructor() {
        super(upload16X16);
    }
}

registerIconSvg('icon-upload', IconUpload);
export const iconUploadTag = 'nimble-icon-upload';
